import * as types from './constants';
// import api from './../_api/exam'
import {getBook} from './../_api/exam'
const getListDocumentPand = ({ commit }, params) => {
 
};

// const actionGetBook = ({ commit }, params = {}) => {
//     getBook(params).then((response) => {
//         commit(types.GET_BOOK, response.data);
//     })
// };
const acSetParamSearch = ({ commit }, data) => {
    commit(types.SET_PARAMS_SEARCH, data);
};
const setBookId = ({ commit }, data) => {
    commit(types.SET_BOOKID, data);
};
const setTypeQuestionCompose = ({ commit }, data) => {
    commit(types.SET_TYPE_QUESTION, data);
};

const workQuestion = ({ commit }, data) => {
    return commit(types.SET_QUESTION_WORK, data);
}
const setParamExam = ({ commit }, data) => {
    return commit(types.SET_PRAM_EXAM, data);
}
const setQuestion = ({ commit }, data) => {
    return commit(types.SET_QUESTION, data);
}

const acSetSlidesMain = ({ commit }, data) => {
    commit(types.SET_SLIDES_MAIN, data);
};

const acSetSlidesImgMain = ({ commit }, data) => {
    commit(types.SET_SLIDES_IMG_MAIN, data);
};

const acSetObjActiSlide = ({ commit }, data) => {
    commit(types.SET_SLIDES_IMG_MAIN, data);
};

const acSetSlideCurr = ({ commit }, data) => {
    commit(types.SET_SLIDE_CURR, data);
};

const acSetSlideVisibleIndex = ({ commit }, data) => {
    commit(types.SET_INDEX_SLIDE_VISIBLE, data || 0);
};

const acSetClasses = ({ commit }, data) => {
    commit(types.SET_CLASSES, data);
};

const acSetLinkAudioVieoViewer = ({ commit }, data) => {
    commit(types.SET_LINK_VIDEO_AUDIO, data);
};

const acSetMediaPreview = ({ commit }, data) => {
    commit(types.SET_DATA_MEDIA_VIEWER, data);
};

const acSetPreviewModalVisibleIndex = ({ commit }, data) => {
    commit(types.SET_PREVIEW_MEDIA_VISIBLE_INDEX, data);
};

const acSetVisibleSlideshow = ({ commit }, data) => {
    commit(types.SET_SLIDESHOW_VISIBLE, data);
};

const acSetParamSearchMediaDetail = ({ commit }, data) => {
    commit(types.SET_PARAM_FILTER_MEDIA_LIST, data);
};

const acSetScaleSlide = ({ commit }, data) => {
    commit(types.SET_SCALE_SLIDE, data);
};
const acSetVisibleModalFileLoaded = ({ commit }, data) => {
    commit(types.SET_VISIBLE_MODAL_FILE_UPLOADED, data);
};
const acSetkeySidebarVisible = ({ commit }, data) => {
    commit(types.SET_KEY_SIDEBAR_VISIBLE, data);
};
const acSetExamPrepareInfo = ({ commit }, data) => {
    commit(types.SET_EXAM_INFO, data);
};
const acSetListQuestions = ({ commit }, data) => {
    commit(types.SET_QUESTION_LIST, data);
};
const acSetQuestionDetail = ({ commit }, data) => {
    commit(types.SET_QUESTION_DETAIL, data);
};
const acSetQuestionIndexWorking = ({ commit }, data) => {
    commit(types.SET_INDEX_QUESTION_WORKING, data);
};
const acSetClassesExam = ({ commit }, data) => {
    commit(types.SET_CLASSES_EXAM, data);
};
const acSetSubjectsExam = ({ commit }, data) => {
    commit(types.SET_SUBJECTS_EXAM, data);
};
const acSetParamsGetQuestionsData = ({ commit }, data) => {
    commit(types.SET_PARAMS_GET_DATA_QUESTION_SAMPLE, data);
};
const acSetBookIdFilterQuestions = ({ commit }, data) => {
    commit(types.SET_BOOKID_FILTER_QUESTION_SAMPLE, data);
};
const acSetBookIndexIdFilterQuestions = ({ commit }, data) => {
    commit(types.SET_BOOKINDEXID_FILTER_QUESTION_SAMPLE, data);
};
const acSetQuestionSample = ({ commit }, data) => {
    commit(types.SET_QUESTIONS_SAMPLE, data);
};
const acSetQuestionsChoosed = ({ commit }, data) => {
    commit(types.SET_QUESTION_CHOOSED, data);
};
const acSetQuestionsIdChoosed = ({ commit }, data) => {
    commit(types.SET_QUESTION_ID_CHOOSED, data);
};
const acSetChapterIdQuestions = ({ commit }, data) => {
    commit(types.SET_CHAPTER_ID_QUESTIONS, data);
};
const acSetParamsFilterQuestionChapter = ({ commit }, data) => {
    commit(types.SET_PARAMS_SEARCH_QUESTION_CHAPTER, data);
};
const acSetParamsFilterQuestionExam = ({ commit }, data) => {
    commit(types.SET_PARAMS_SEARCH_QUESTION_EXAM, data);
};

export default {
    getListDocumentPand,
    acSetParamSearch,
    workQuestion,
    setParamExam,
    setBookId,
    setQuestion,
    acSetSlidesMain,
    acSetSlidesImgMain,
    acSetObjActiSlide,
    acSetSlideCurr,
    acSetSlideVisibleIndex,
    acSetClasses,
    acSetMediaPreview,
    acSetLinkAudioVieoViewer,
    acSetVisibleSlideshow,
    acSetPreviewModalVisibleIndex,
    acSetParamSearchMediaDetail,
    acSetScaleSlide,
    setTypeQuestionCompose,
    acSetVisibleModalFileLoaded,
    acSetkeySidebarVisible,
    acSetExamPrepareInfo,
    acSetListQuestions,
    acSetQuestionDetail,
    acSetQuestionIndexWorking,
    acSetClassesExam,
    acSetParamsGetQuestionsData,
    acSetBookIdFilterQuestions,
    acSetBookIndexIdFilterQuestions,
    acSetQuestionSample,
    acSetQuestionsChoosed,
    acSetQuestionsIdChoosed,
    acSetChapterIdQuestions,
    acSetSubjectsExam,
    acSetParamsFilterQuestionChapter,
    acSetParamsFilterQuestionExam
};